"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");

var EANValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(EANValidator, _Validator_1$Validato);

  function EANValidator() {
    _classCallCheck(this, EANValidator);

    return _possibleConstructorReturn(this, _getPrototypeOf(EANValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
  }

  _createClass(EANValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (/^[0-9]+$/.test(value.value)) {
        return new ValidationResult_1.ValidationSuccess(value);
      }

      return new ValidationResult_1.ValidationError(EANValidator.BAD_EAN_FORMAT_ERROR);
    }
  }]);

  return EANValidator;
}(Validator_1.Validator);

exports.EANValidator = EANValidator;
EANValidator.BAD_EAN_FORMAT_ERROR = 'BAD_EAN_FORMAT';